<template>
  <div class="my-8">
    <div class="tickets-dashboard-graph-container">
        <div ref="ticketsLocationGraph" style="width: 100%; height: 100%; overflow: hidden;"></div>
    </div>
  </div>
</template>

<script>
const echarts = require('echarts');
import { EventBus } from '../../../../../../eventBus';
export default {
    name: "LocationInsightsDashboardGraph",
    props: {
        graphValues: {
            required: true,
            type: Array,
        },
        graphColors: {
            type: Array,
            required: true,
        },
        graphLabels: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            ticketLocationGraphInstance: '',
            option: {
                color: [],

                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    right: '15%'
                },
                legend: {
                    show: false,
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: []
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        min: 0,
                        interval:25,
                        max: 100,
                        position: 'left',
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#333333'
                            }
                        },
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: [
                    {
                        name: 'Category %',
                        type: 'bar',
                        yAxisIndex: 0,
                        barWidth: 50,
                        data: [
                            {
                                value: 91,
                                itemStyle: {
                                    color: '#d26300'
                                }
                            },
                            {
                                value: 86,
                                itemStyle: {
                                    color: '#d67e31'
                                }
                            },
                        ],
                        label: {
                            show: true,
                            position: 'top',
                            color: '#FFFFFF',
                            backgroundColor: '#d26300',
                            padding: 4,
                            fontSize: 12,
                            formatter: '{c}%'
                        }
                    }
                ]
            }
        }
    },
    watch: {
        graphValues(newValue, oldValue) {
            this.reRenderGraph();
        }
    },
    mounted() {
        setTimeout(() => {
            this.reRenderGraph();
        }, 100);
    },
    methods:{
        initGraph() {
            let chartContainer = this.$refs.ticketsLocationGraph;
            this.ticketLocationGraphInstance = echarts.init(chartContainer);
        },
        reRenderGraph() {
            this.initGraph();
            // this.ticketLocationGraphInstance.showLoading();
            this.option.color = [...this.graphColors];
            this.option.series[0].data = this.graphValues.map((el, index) => ({
                value: el,
                itemStyle: {
                    color: this.graphColors[index]
                }
            }));
            this.option.xAxis[0].data = this.graphLabels.map(el => el);
            this.ticketLocationGraphInstance.setOption(this.option);
            // this.ticketLocationGraphInstance.hideLoading();
        }
    }

}
</script>

<style>
.tickets-dashboard-graph-container{
    background-color:#ffffff;
    /* padding:25px; */
    height:300px;
    width:100%;
    margin: 20px 0;

}
</style>